<script lang="ts">
    import {Flex, Spacer, getPageContext} from 'shared/layouts';
    import {RecordFieldsDetailGrid} from 'src/features/erp-sutor/features/record-fields-detail-grid';
    import {getInjector} from 'src/core';
    import type {
        DocumentDetailReactivePageData,
        DocumentDetailStaticPageData
    } from 'src/features/record/kp-document-detail-page/types';
    import {
        DocumentDetailTabsetService
    } from 'src/features/record/kp-document-detail-tabset/document-detail-tabset.service';
    import {onMount} from 'svelte';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {getSutorFondIcon} from '../sutor-fond-icon-lookup';
    import {exists} from 'shared/utils/custom-utils';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';
    import GenericRecordIcon from '../components/GenericRecordIcon.svelte';

    const service = getInjector().getByClass(DocumentDetailTabsetService);
    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;

    const operationPageableList = service.createOperationPageableList(model.record);
    const recordIcon = getSutorFondIcon(model.record.fond);

    onMount(() => {
        operationPageableList.loadFirstPage();
    });
</script>

<Flex direction="column">
    <Flex direction="row" alignItems="center">
        {#if exists(recordIcon)}
            <GenericRecordIcon icon={recordIcon} fond={model.record.fond}/>
            <Spacer direction="horizontal" size="ml"/>
        {/if}

        <Flex direction="row" alignItems="baseline">
            <KpHeading type="h1">{model.record.text}</KpHeading>
            <Spacer direction="horizontal" size="ml"/>
            <small class="text-muted">Fond '{pipe(model.record.fond, loc())}' (ID {model.record.fond.id})</small>
        </Flex>
    </Flex>
    <Spacer direction="vertical" size="xl"/>
    <Spacer direction="vertical" size="xxl"/>

    <RecordFieldsDetailGrid record={model.record}/>
</Flex>